"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RecentIcon = function RecentIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M9 4v4h3v2H7V4zM8 0a7.959 7.959 0 0 0-6 2.727V0H0v6h6V4H3.557a5.984 5.984 0 1 1-.791 6.928L1.232 12.25A7.996 7.996 0 1 0 8 0z"
    }) : _react["default"].createElement("path", {
      d: "M16 8.5a7.493 7.493 0 0 1-13.606 4.34l.756-.653a6.518 6.518 0 1 0 .535-8.021L2.935 5H6v1H1V1h1v3.554l.876-.998A7.49 7.49 0 0 1 16 8.5zM8 5v5h4V9H9V5z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M13 6v6h4v2h-6V6zm-1.061-5A10.96 10.96 0 0 0 3 5.614V1H1v8h8V7H4.476a8.995 8.995 0 1 1-.137 9.8l-1.796.898A10.995 10.995 0 1 0 11.939 1z"
    }) : _react["default"].createElement("path", {
      d: "M23 12.5a10.5 10.5 0 0 1-19.7 5.058l.871-.495A9.515 9.515 0 1 0 3.687 9H8v1H2V4h1v4.068A10.488 10.488 0 0 1 23 12.5zM12 7v7h5v-1h-4V7z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M17 7v10h8v2H15V7zm-.5-5A14.456 14.456 0 0 0 5 7.691V3H2v10h10v-3H7.02a11.5 11.5 0 1 1-.752 11.732l-2.202 2.202A14.494 14.494 0 1 0 16.5 2z"
  }) : _react["default"].createElement("path", {
    d: "M30 16.5a13.49 13.49 0 0 1-24.66 7.573l.717-.716a12.5 12.5 0 1 0 .14-13.923L5.12 11H10v1H3V5h1v5.64L5.794 8.3A13.488 13.488 0 0 1 30 16.5zM16 7v11h9v-1h-8V7z"
  }));
};

var _default = RecentIcon;
exports["default"] = _default;